export const validateName = async (rule, value) => {
  if (value && value.length < 2) {
    throw new Error("Debe tener al menos 2 caracteres de longitud");
  }

  if (value && !/^[a-zA-Za-zÑñáéíóúÁÉÍÓÚ\s.'-]+$/.test(value)) {
    throw new Error("Debe contener solamente caracteres alfabeticos");
  }
};

export const validateAddress = async (rule, value) => {
  if (value && value.length < 5) {
    throw new Error("Debe tener almenos 5 caracteres de longitud");
  }
};

export const validateCellPhone = async (rule, value) => {
  if (value && !/^[0-9]{9}$/.test(value)) {
    throw new Error("Debe contener un numero de 9 digitos");
  }
};

export const validateIdentificationNumber = async (rule, value) => {
  const dniRegex = /^[0-9]{8}$/;
  const rucRegex = /^[0-9]{11}$/;

  if (value && !(dniRegex.test(value) || rucRegex.test(value))) {
    throw new Error(
      "El número de identificación debe ser un DNI o un RUC válido"
    );
  }
};
